import { useContext, type Dispatch, type SetStateAction } from 'react';

import { SetWillRedirectOnLoadContext } from '../will-redirect-on-load-contexts';

export const useSetWillRedirectOnLoad = (): Dispatch<SetStateAction<boolean>> =>
	useContext(SetWillRedirectOnLoadContext);
